import * as moment from 'moment';
// import { FormatHelper } from "../helpers/Formater";
import { TimePickerService } from '../services/TimePicker';
import { MeetingTypes } from '../shared/MeetingTypes';
import { PaymentTypes } from '../shared/PaymentTypes';

function randomStartDate(userAvFrom, userAvTo) {
  const cardHours = moment(userAvFrom * 1000).format('HH');
  const cardMinutes = moment(userAvFrom * 1000).format('mm');
  const diff = moment(userAvTo * 1000).diff(userAvFrom * 1000, 'minutes');

  let startSteps = +diff / 15;

  if (startSteps >= 2) {
    startSteps = startSteps - 2;
  }

  const steps = Math.floor(Math.random() * startSteps);

  const minutes = steps * 15;
  const date = moment(userAvFrom * 1000)
    .set('hours', cardHours)
    .set('minutes', cardMinutes)
    .set('seconds', 0);

  const resultDate = moment(date)
    .add(minutes, 'minutes')
    .unix();

  return resultDate;
}

function randomEndTime(cardTimeFrom, userAvTo) {
  const cardHours = moment(cardTimeFrom * 1000).format('HH');
  const cardMinutes = moment(cardTimeFrom * 1000).format('mm');
  const diff = moment(userAvTo * 1000).diff(cardTimeFrom * 1000, 'minutes');

  const startSteps = +diff / 15;

  let steps = 0;
  if (startSteps === 1) {
    steps = 1;
  } else if (startSteps > 3) {
    steps = Math.floor(Math.random() * (startSteps - 4)) + 4;
  } else {
    steps = Math.floor(Math.random() * (startSteps - 2)) + 2;
  }

  const minutes = steps * 15;
  const date = moment(cardTimeFrom * 1000)
    .set('hours', cardHours)
    .set('minutes', cardMinutes)
    .set('seconds', 0);

  const resultDate = moment(date)
    .add(minutes, 'minutes')
    .unix();

  return resultDate;
}

function filterFakeCardsByDurationTime(userAvFrom, userAvTo) {
  return mocksCards.map(card => {
    card.time_from = randomStartDate(userAvFrom, userAvTo);
    card.time_to = randomEndTime(card.time_from, userAvTo);

    const meetingTimeWindow = (card.time_to - card.time_from) / 60;

    if (meetingTimeWindow < card.duration_time) {
      card.duration_time = 30;
    }

    if (meetingTimeWindow < 30) {
      card.duration_time = 15;
    }

    return card;
  });
}

export const getFakeCards = () => {
  // const user = FormatHelper.getEmptyUserInfoForRedux();

  // let userAvStart = user.availabilityFrom;
  // let userAvEnd = user.availabilityTo;

  let userAvStart = moment()
    .startOf('day')
    .unix();
  let userAvEnd = moment(TimePickerService.getRoundedTime())
    .add(15, 'days')
    .startOf('day')
    .unix();

  // if (moment(userAvStart * 1000).isBefore(moment())) {
  //   userAvStart = moment(TimePickerService.getRoundedTime()).unix();
  //   userAvEnd = moment(TimePickerService.getRoundedTime())
  //     .add(2, "h")
  //     .unix();
  //
  //   if (
  //     userAvEnd >
  //     moment()
  //       .add(1, "d")
  //       .startOf("day")
  //       .unix()
  //   ) {
  //     userAvEnd = moment()
  //       .add(1, "d")
  //       .startOf("day")
  //       .add(-15, "m")
  //       .unix();
  //   }
  // }

  const cards = filterFakeCardsByDurationTime(userAvStart, userAvEnd);

  return cards;
};

const mocksCards = [
  {
    description: 'One Family Fund',
    duration_time: 60,
    id: '1',
    short_description: 'The Last Dance on Netflix',
    time_from: 1593442800,
    time_to: 1593450000,
    user: {
      age: 28,
      education: 'Baruch College',
      name: 'Tina Brown',
      photoURL:
        'https://firebasestorage.googleapis.com/v0/b/coffee-me-dev.appspot.com/o/images%2F1593418017957images.jpg?alt=media&token=f51f0716-899f-463b-9d1a-24607ef05ce6',
      authMethods: {
        google: true,
        facebook: false,
        apple: false
      }
    },
    status: null,
    fake: true,
    payment_type: PaymentTypes.FUNDRAISER,
    payment_amount: 15,
    type: MeetingTypes.ZOOM_GROUP
  },
  {
    description: 'FIDF',
    duration_time: 60,
    id: '2',
    short_description: 'Bitcoin and Cryptos',
    time_from: 1593442800,
    time_to: 1593450000,
    coffees: null,
    user: {
      age: 33,
      education: 'Columbia University',
      name: 'Lily Bennett',
      photoURL:
        'https://firebasestorage.googleapis.com/v0/b/coffee-me-dev.appspot.com/o/images%2F1593418144696Promobl6618.jpg?alt=media&token=587f194f-5652-478c-aed3-3adf766b0809',
      authMethods: {
        google: true,
        facebook: false,
        apple: false
      }
    },
    status: null,
    fake: true,
    payment_type: PaymentTypes.FUNDRAISER,
    payment_amount: 5,
    type: MeetingTypes.ZOOM_GROUP
  },
  {
    description: "United Hatzalah",
    duration_time: 60,
    id: '3',
    short_description: 'The Science of Happiness',
    time_from: 1593442800,
    time_to: 1593450000,
    user: {
      age: 29,
      name: 'Joe Newman',
      education: 'New York University',
      photoURL:
        'https://firebasestorage.googleapis.com/v0/b/coffee-me-dev.appspot.com/o/images%2F15934184100851253603.jpg?alt=media&token=777825f7-67a0-4f43-bfb3-e64dbe1e6476',
      authMethods: {
        google: true,
        facebook: false,
        apple: false
      }
    },
    status: null,
    fake: true,
    payment_type: PaymentTypes.FUNDRAISER,
    payment_amount: 8,
    type: MeetingTypes.ZOOM_GROUP
  },
  {
    description: "StandWithUs",
    duration_time: 60,
    id: '4',
    short_description: 'Sport Events',
    time_from: 1593442800,
    time_to: 1593450000,
    user: {
      age: 31,
      name: 'Hendrix Graham',
      education: 'Baruch College',
      photoURL:
        'https://firebasestorage.googleapis.com/v0/b/coffee-me-dev.appspot.com/o/images%2F1593419214298download.jpg?alt=media&token=c029f136-b5ee-44bc-bcc9-3d72c282018d',
      authMethods: {
        google: false,
        facebook: true,
        apple: false
      }
    },
    status: null,
    fake: true,
    coffees: null,
    payment_type: PaymentTypes.FUNDRAISER,
    payment_amount: 20,
    type: MeetingTypes.ZOOM_GROUP
  },
  {
    description: "Latet",
    duration_time: 60,
    id: '5',
    short_description: 'Investing in Stocks',
    time_from: 1593442800,
    time_to: 1593450000,
    user: {
      age: 24,
      name: 'Leighton Richards',
      education: 'Columbia University',
      photoURL:
        'https://firebasestorage.googleapis.com/v0/b/coffee-me-dev.appspot.com/o/images%2F1593419436001ahn-hyoseop-profile-cover.jpg?alt=media&token=c53415db-c7dc-48e9-bf16-3e70548eb339',
      authMethods: {
        google: true,
        facebook: false,
        apple: false
      }
    },
    status: null,
    fake: true,
    payment_type: PaymentTypes.FUNDRAISER,
    payment_amount: 5,
    type: MeetingTypes.ZOOM_GROUP
  },
  {
    description: "Assuta Hospital",
    duration_time: 60,
    id: '6',
    short_description: 'Brand Avatars',
    time_from: 1593442800,
    time_to: 1593450000,
    user: {
      age: 29,
      name: 'Dominic Robinson',
      education: 'New York University',
      photoURL:
        'https://firebasestorage.googleapis.com/v0/b/coffee-me-dev.appspot.com/o/images%2F1593419513223rob.jpg?alt=media&token=1424686f-f665-49ef-bd74-047725c426ef',
      authMethods: {
        google: true,
        facebook: false,
        apple: false
      }
    },
    status: null,
    fake: true,
    coffees: null,
    payment_type: PaymentTypes.FUNDRAISER,
    payment_amount: 12,
    type: MeetingTypes.ZOOM_GROUP
  },
  {
    description: "Pitchon Lev",
    duration_time: 60,
    id: '7',
    short_description: 'Traveling at This Time',
    time_from: 1593442800,
    time_to: 1593450000,

    user: {
      age: 30,
      name: 'Serena Hayes',
      education: 'The Julliard School',
      photoURL:
        'https://firebasestorage.googleapis.com/v0/b/coffee-me-dev.appspot.com/o/images%2F159341925921236%20(1).jpg?alt=media&token=abfe1205-9dc5-48bb-a212-b6587b4c3f9b',
      authMethods: {
        google: false,
        facebook: false,
        apple: true
      }
    },
    status: null,
    fake: true,
    payment_type: PaymentTypes.FUNDRAISER,
    payment_amount: 10,
    type: MeetingTypes.ZOOM_GROUP
  },
  {
    description: "Magen David Adom",
    duration_time: 60,
    id: '8',
    short_description: 'Little Italy or Soho?',
    time_from: 1593442800,
    time_to: 1593450000,
    user: {
      age: 25,
      name: 'Miriam Jenkins',
      education: 'The City College of New York',
      photoURL:
        'https://firebasestorage.googleapis.com/v0/b/coffee-me-dev.appspot.com/o/images%2F1593419309450cute-hair-styles-25-new-afro-hairstyles-2017-short-hairstyles-2017-2018-most.jpg?alt=media&token=f023d068-0540-45db-8ff4-06df27bf21a0',
      authMethods: {
        google: false,
        facebook: false,
        apple: true
      }
    },
    status: null,
    fake: true,
    payment_type: PaymentTypes.FUNDRAISER,
    payment_amount: 5,
    type: MeetingTypes.ZOOM_GROUP
  },
];
